import React from 'react';
import { UnableToDeactivateProps } from './unable-to-deactivate.types';
import { Flex, Text } from 'common/common-components.styled';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import IconHover from 'components/icon-hover';
import { QuestionIcon } from 'components/icons-new/question';
import InfoHint from 'components/info-hint/info-hint-view';
import { InfoHintType } from 'components/info-hint/info-hint.props';

export const isShowInfoHint = (lastRequestDate?: string | null) => {
  if (!lastRequestDate) {
    return false;
  }

  return moment().diff(moment(lastRequestDate), 'days') < 3;
};

const UnableToDeactivate = ({ configuration }: UnableToDeactivateProps) => {
  if (!configuration) {
    return null;
  }

  return (
    <Flex top='20'>
      <InfoHint type={InfoHintType.Warning}>
        {isShowInfoHint(configuration?.uds_remove_request_date?.value)
          ? `Archivierung wurde angefragt: ${moment(configuration?.uds_remove_request_date?.value).format(
              'DD.MM.YYYY'
            )}. Bitte wähle eine neue Koniguration.`
          : 'Diese Konfiguration wurde bereits bearbeitet. Um sie zu archivieren, ist eine Anfrage an einen Mobexo-Mitarbeiter erforderlich. Bitte klicke auf den Button „Archivierung anfragen“ – wir kümmern uns darum.'}
      </InfoHint>
    </Flex>
  );
};

export default UnableToDeactivate;
